module.exports = __webpack_public_path__ + "img/abstract-shapes-1.44ea0b2a.svg";